import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './CaseInfoScreen';
import CaseInfo from './CaseInfoScreen';
import { StoreState } from 'src/store/reducers';
import { getCase, getFiles } from 'src/store/actions/case-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        caseEnt: state.cases.current,
        files: state.cases.currentFiles,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getCase(id)),
        getFiles: (id) => dispatch(getFiles(id)),
    };
}

const CaseInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(CaseInfo);

export default CaseInfoScreen;
